import { CatalogColombia, CatalogsEnum } from "./CatalogColombia";
export var catalog_cities_co = new CatalogColombia().getCatalog(CatalogsEnum.cities);
export var catalog_departments_co = new CatalogColombia().getCatalog(CatalogsEnum.departments);
